import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';
import {
  useGetExerciseContentByContentId,
  useGetExerciseReport,
  useGetAllSubmissionByContentIdAndDate,
} from '_api';
import { ReportChart, DateRangeSelector } from 'components/organisms';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { IoMdArrowBack } from 'react-icons/io';

import { ActivitySubmission } from '../organisms/modals/ActivitySubmission';

import { ReportViewProps } from './types';

export const ExerciseReport = ({ id }: ReportViewProps) => {
  const theme = useTheme();
  const { data: exerciseContent, isFetching: loadingContent } =
    useGetExerciseContentByContentId(id);
  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
  });

  const {
    data: exerciseReport,
    isFetching,
    isFetched,
    refetch,
  } = useGetExerciseReport(id, dateRange.startDate, dateRange.endDate);
  const [showNotes, setShowNotes] = useState(false);
  const { data: activitySubmission, isLoading: isLoadingNotes } =
    useGetAllSubmissionByContentIdAndDate(id);

  useEffect(() => {
    if (!isFetching) refetch();
  }, [dateRange]);

  const handleRangeChange = ({
    startDate,
    endDate,
  }: {
    startDate: string;
    endDate: string;
  }) => {
    setDateRange({ startDate, endDate });
  };

  if (!exerciseReport && !isFetching) {
    return <Typography variant="h6">Exercise Report Not Found...</Typography>;
  }

  const handleBack = () => {
    history.back();
  };

  var assignedDate = exerciseContent?.schedules[0].startDate;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', paddingTop: '50px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ marginTop: '10px', color: `${theme.palette.primary.main}` }}>
          <IoMdArrowBack />
        </Box>
        <Button onClick={handleBack} sx={{ justifyContent: 'left' }}>
          {' '}
          Back{' '}
        </Button>
      </Box>
      <Typography variant={'h3'} gutterBottom>
        {!loadingContent ? exerciseContent?.content.title : ''}
      </Typography>
      {exerciseReport !== undefined && !loadingContent && isFetched ? (
        <Box>
          <DateRangeSelector onChange={handleRangeChange} onNotesClick={setShowNotes} />
          {!showNotes && exerciseReport ? (
            <ReportChart
              assignedDate={assignedDate}
              schedules={exerciseContent?.schedules || []}
              endDate={dateRange.endDate}
              hideAverage={true}
              report={exerciseReport}
              startDate={dateRange.startDate}
              xAxisLabel={'Date'}
              completedDate={exerciseContent?.completedDate}
              yearAggregation="total"
            />
          ) : !isLoadingNotes && activitySubmission ? (
            <ActivitySubmission data={activitySubmission} />
          ) : (
            <CircularProgress size={60} />
          )}
        </Box>
      ) : (
        <Box sx={{ margin: 'auto' }}>
          <CircularProgress size={60} />
        </Box>
      )}
    </Box>
  );
};
